import { FC, useEffect } from 'react';
import { BrokerSpecificComponentsProps } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';
import UserInput from 'v3/common/components/UserInput';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import Button from 'v3/common/components/Button';

const JainamBroking: FC<BrokerSpecificComponentsProps> = ({ userConfigs, brokerSpecificHandles }) => {
  const { validateClientId, updatePartialConfigs, reDirectPage, isMobile } = brokerSpecificHandles;
  const {
    clientId,
    isLoading,
    isClientValidated,
    shouldShowApiKey,
    shouldShowSecretKey,
    apiKey,
    secretKey,
    brokerVariant,
    isValidForm,
    selectedBrokerConfig,
  } = userConfigs;

  const broker = selectedBrokerConfig?.id;

  // Temp fix to set broker variant
  useEffect(() => {
    updatePartialConfigs({
      brokerVariant: 'retail',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderUserType = () => {
    return (
      <div className="user-input__container">
        <label htmlFor="userType">UserType</label>
        <select
          name="userType"
          id="userType"
          value={brokerVariant}
          onChange={(e) => updatePartialConfigs({ brokerVariant: e.target.value })}
          disabled={isClientValidated}
        >
          <option value="retail">Retail</option>
          <option value="cf_1">CF 1</option>
          <option value="prop_a">XTS A</option>
          <option value="prop_b">XTS B</option>
          <option value="prop_c">XTS C</option>
          <option value="prop_d">XTS D</option>
        </select>
      </div>
    );
  };

  return (
    <form
      id={`${broker}-form`}
      onSubmit={(e) => {
        e.preventDefault();
        return isClientValidated
          ? reDirectPage({ user_type: brokerVariant }, false)
          : validateClientId({ broker: `jainam_broking_${brokerVariant}` });
      }}
    >
      <UserInput
        autoFocus={!isMobile}
        labelValue="Client Id"
        id={`${broker}-client-id`}
        value={clientId}
        isDisabled={isClientValidated}
        onHandleChange={(value) => updatePartialConfigs({ clientId: value })}
      />

      {renderUserType()}

      {shouldShowApiKey && (
        <UserInput
          labelValue="API Key"
          id={`${broker}-api-key`}
          value={apiKey}
          onHandleChange={(value) => updatePartialConfigs({ apiKey: value })}
        />
      )}

      {shouldShowSecretKey && (
        <UserInput
          labelValue="API Secret"
          id={`${broker}-secret-key`}
          value={secretKey}
          onHandleChange={(value) => updatePartialConfigs({ secretKey: value })}
        />
      )}

      {isClientValidated && (
        <div className="my-2 alert alert-warning py-1 px-2">
          Please contact JainamBroking support to get your API Key and Secret Key
        </div>
      )}

      {!isValidForm && <div className="invalid-feedback d-block">Please provide the details</div>}

      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        <Button type="submit" isLoading={isLoading} form={`${broker}-form`}>
          {isClientValidated ? 'Login' : 'Validate'}
        </Button>
      </PortalToTarget>
    </form>
  );
};

export default JainamBroking;
